// 未使用の決済方法は表示しない
export const PAYMENT_METHOD_NAMES = [
  '銀行振込',
  'クレジットカード',
  'コンビニ',
  '', // 銀行振込(AGT)
  '', // 国内コンビニ
  '', // 海外コンビニ
  'あと払い（ペイディ）',
  'Amazon Pay',
  'PayPay',
  'd払い',
];

export const LOADING_TEXT_APPLICATION_EXEC = 'お申込み処理を行っております';
export const PAYMENT_UNAVAILABLE_MESSAGE =
  '申し訳ありません、ただ今サービスに障害が発生しております。 ';
export const CHANGE_METHOD_MESSAGE =
  'お支払方法変更を申請致しました。後ほど、ご連絡申し上げます。';
export const SYSTEM_ERROR_MESSAGE =
  'システムエラーが発生しました。お手数ですが、しばらく時間を置いてから再度お試しください。';
export const PAYMENT_METHODS = {
  BANK_TRANSFER: 1,
  CARD: 2,
  CONVENI: 3,
  PAIDY: 7,
  AMAZON_PAY: 8,
  PAYPAY: 9,
  DOCOMO: 10,
};

export const PAYMENT_CATEGORIES = {
  PAYMENT_LATER: 0,
  PAYMENT_NOW_CARD: 1,
  PAYMENT_NOW_PAIDY: 2,
  PAYMENT_NOW_AMAZON_PAY: 3,
  PAYMENT_NOW_PAYPAY: 4,
  PAYMENT_NOW_DOCOMO: 5,
};

/**
 * AmazonPayを除く即時決済カテゴリの配列
 * クレジットカード、Paidy、PayPay、d払いが対象
 * isImmediateParentSelected や initializeExpansionStates 等で使用
 */
export const IMMEDIATE_PAYMENT_CATEGORIES = [
  PAYMENT_CATEGORIES.PAYMENT_NOW_CARD,
  PAYMENT_CATEGORIES.PAYMENT_NOW_PAIDY,
  PAYMENT_CATEGORIES.PAYMENT_NOW_PAYPAY,
  PAYMENT_CATEGORIES.PAYMENT_NOW_DOCOMO,
];

/**
 * AmazonPayを含む全ての即時決済カテゴリの配列
 * usePaymentCategory の setter 等で使用
 */
export const ALL_IMMEDIATE_PAYMENT_CATEGORIES = [
  PAYMENT_CATEGORIES.PAYMENT_NOW_AMAZON_PAY,
  ...IMMEDIATE_PAYMENT_CATEGORIES,
];
export const PAYMENT_CATEGORIES_FOR_HOTEL = [
  PAYMENT_CATEGORIES.PAYMENT_LATER,
  PAYMENT_CATEGORIES.PAYMENT_NOW_CARD,
  PAYMENT_CATEGORIES.PAYMENT_NOW_PAIDY,
  PAYMENT_CATEGORIES.PAYMENT_NOW_AMAZON_PAY,
];
export const PAYMENT_STATUS = {
  NOT_PAYMENT_YET: 0,
  PAID: 1,
  CANCEL_BOOKING: 2,
};

// 決済処理専用のリトライ回数（ホテル予約のポーリング等で使用）
// 申込処理全般のリトライ回数はConstants.MAX_RETRY_APPLICATION (25回) を使用
export const MAX_RETRY = 10;
export const WAITING_MSEC = 4000;
